module.exports = __webpack_public_path__ + "static/media/mentorships.6e4e969d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/ProgramTimeline/img/mentorships.svg
// module id = 238
// module chunks = 0